import React, { useState, useEffect } from 'react';
import { clientesApi } from '../services/api';

const Clientes = () => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [estadoFiltro, setEstadoFiltro] = useState('activos');
  const [pagination, setPagination] = useState({ page: 1, pages: 1, total: 0 });
  const [showModal, setShowModal] = useState(false);
  const [editingCliente, setEditingCliente] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    correo_electronico: '',
    direccion: ''
  });

  useEffect(() => {
    loadClientes(1);
  }, [estadoFiltro]);

  const loadClientes = async (page = 1) => {
    setLoading(true);
    try {
      const params = { page, limit: 20, estado: estadoFiltro };
      if (searchTerm.length >= 2) params.q = searchTerm;
      const response = await clientesApi.getAll(params);
      setClientes(response.data || []);
      setPagination(response.pagination || { page: 1, pages: 1, total: 0 });
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    loadClientes(1);
  };

  const handleOpenModal = (cliente = null) => {
    if (cliente) {
      setEditingCliente(cliente);
      setFormData({
        nombre: cliente.nombre,
        telefono: cliente.telefono || '',
        correo_electronico: cliente.correo_electronico || '',
        direccion: cliente.direccion || ''
      });
    } else {
      setEditingCliente(null);
      setFormData({ nombre: '', telefono: '', correo_electronico: '', direccion: '' });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingCliente(null);
    setFormData({ nombre: '', telefono: '', correo_electronico: '', direccion: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingCliente) {
        await clientesApi.update(editingCliente.id, formData);
      } else {
        await clientesApi.create(formData);
      }
      loadClientes();
      handleCloseModal();
    } catch (error) {
      alert('Error al guardar el cliente');
    }
  };

  const handleDesactivar = async (id) => {
    if (!window.confirm('¿Desactivar este cliente? Ya no aparecerá en la lista, pero puedes reactivarlo después.')) return;
    try {
      await clientesApi.delete(id);
      loadClientes(pagination.page);
    } catch (error) {
      alert('Error al desactivar el cliente');
    }
  };

  const handleActivar = async (cliente) => {
    try {
      await clientesApi.update(cliente.id, { ...cliente, activo: true });
      loadClientes(pagination.page);
    } catch (error) {
      alert('Error al activar el cliente');
    }
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Clientes</h1>
          <p className="page-subtitle">{pagination.total} clientes {estadoFiltro === 'inactivos' ? 'inactivos' : estadoFiltro === 'todos' ? 'en total' : 'activos'}</p>
        </div>
        <button onClick={() => handleOpenModal()} className="btn btn-primary">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Nuevo Cliente
        </button>
      </div>

      <div className="filters-bar">
        <form onSubmit={handleSearch} className="search-input">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input
            type="text"
            placeholder="Buscar por nombre, teléfono o correo..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control"
            style={{ paddingLeft: '40px' }}
          />
        </form>
        <select
          className="form-control"
          style={{ width: 'auto', minWidth: '150px' }}
          value={estadoFiltro}
          onChange={(e) => setEstadoFiltro(e.target.value)}
        >
          <option value="activos">Activos</option>
          <option value="inactivos">Inactivos</option>
          <option value="todos">Todos</option>
        </select>
      </div>

      <div className="card">
        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : clientes.length === 0 ? (
          <div className="empty-state">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            <h3>No hay clientes</h3>
            <p>Registra tu primer cliente</p>
          </div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Correo</th>
                  <th>Dirección</th>
                  <th>Órdenes</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {clientes.map(cliente => (
                  <tr key={cliente.id}>
                    <td style={{ fontWeight: 500 }}>{cliente.nombre}</td>
                    <td>{cliente.telefono || '-'}</td>
                    <td>{cliente.correo_electronico || '-'}</td>
                    <td>{cliente.direccion?.substring(0, 30) || '-'}</td>
                    <td>
                      <span className="status-badge status-proceso">
                        {cliente.total_ordenes || 0}
                      </span>
                    </td>
                    <td>
                      <div className="table-actions">
                        <button
                          onClick={() => handleOpenModal(cliente)}
                          className="btn btn-secondary btn-icon"
                          title="Editar"
                        >
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                          </svg>
                        </button>
                        {cliente.activo == 0 ? (
                          <button
                            onClick={() => handleActivar(cliente)}
                            className="btn btn-success btn-sm"
                            title="Activar"
                          >
                            Activar
                          </button>
                        ) : (
                          <button
                            onClick={() => handleDesactivar(cliente.id)}
                            className="btn btn-danger btn-sm"
                            title="Desactivar"
                          >
                            Desactivar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {pagination.pages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '20px' }}>
            {Array.from({ length: pagination.pages }, (_, i) => i + 1).map(page => (
              <button
                key={page}
                className={`btn ${page === pagination.page ? 'btn-primary' : 'btn-secondary'} btn-sm`}
                onClick={() => loadClientes(page)}
              >
                {page}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">
                {editingCliente ? 'Editar Cliente' : 'Nuevo Cliente'}
              </h2>
              <button className="modal-close" onClick={handleCloseModal}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Nombre *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.nombre}
                    onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Teléfono</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.telefono}
                    onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Correo Electrónico</label>
                  <input
                    type="email"
                    className="form-control"
                    value={formData.correo_electronico}
                    onChange={(e) => setFormData({ ...formData, correo_electronico: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Dirección</label>
                  <textarea
                    className="form-control"
                    value={formData.direccion}
                    onChange={(e) => setFormData({ ...formData, direccion: e.target.value })}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Clientes;
